// import external dependencies
import 'jquery';

// Import everything from autoload
import './autoload/_bootstrap.js'

// import local dependencies
import Router from './util/Router';
import common from './routes/common';
import home from './routes/home';
import aboutUs from './routes/about';
import LocomotiveScroll from 'locomotive-scroll';

/** Populate Router instance with DOM routes */
const routes = new Router({
  // All pages
  common,
  // Home page
  home,
  // About Us page, note the change from about-us to aboutUs.
  aboutUs,
});

//search 
jQuery(window).load(function () {

  setTimeout(function () {
    document.getElementById('search-bar').style.display = 'block';
  }, 2000);

});


$( '.search-toggle, .search-bar .close' ).click(function() {
  $( '.search-bar' ).toggleClass( 'searching');
});

//menu

$( '.menu-toggle a' ).click(function() {
  $( 'nav.nav-primary' ).slideToggle( 'slow', function() {   });
  $('.menu-toggle').toggleClass('active');
});

//accordians

$('ul.accordian li.item').click(function() {
  $(this).children('p').slideToggle( 'slow', function() {   });
  $( this).toggleClass( 'active');
});

//team toggles
$('.toggle').click(function() {
  $(this).next('.contents').slideToggle( 'slow', function() {   });
  $( this).toggleClass( 'active');
});


//tabs

$('.resources').click(function() {
  document.getElementById('small-caps').style.display = 'none';
  document.getElementById('resources').style.display = 'grid';
  $(this).addClass( 'active');
  $('.small-caps').removeClass( 'active');
});

$('.small-caps').click(function() {
  document.getElementById('resources').style.display = 'none';
  document.getElementById('small-caps').style.display = 'grid';
  $(this).addClass( 'active');
  $('.resources').removeClass( 'active');
});

// locomotive scroll

const locoScroll = new LocomotiveScroll({
  el: document.querySelector('.smooth-scroll'),
  smooth: true,
});


// Register gsap

import { gsap } from 'gsap';
import { SlowMo } from 'gsap/EasePack';
import { ScrollTrigger } from 'gsap/ScrollTrigger';
import { DrawSVGPlugin } from 'gsap/DrawSVGPlugin';

gsap.registerPlugin(ScrollTrigger, DrawSVGPlugin, SlowMo);

// loco & scrolltrigger

locoScroll.on('scroll', ScrollTrigger.update);

ScrollTrigger.scrollerProxy('.smooth-scroll', {
  scrollTop(value) {
    return arguments.length ? locoScroll.scrollTo(value, 0, 0) : locoScroll.scroll.instance.scroll.y;
  }, 
  getBoundingClientRect() {
    return {top: 0, left: 0, width: window.innerWidth, height: window.innerHeight};
  },
  
  pinType: document.querySelector('.smooth-scroll').style.transform ? 'transform' : 'fixed',
});


//menu
const showAnim = gsap.from('header.banner', { 
  yPercent: -100,
  paused: true,
  scroller: '.smooth-scroll',
  duration: 0.2,
}).progress(1);

ScrollTrigger.create({
  start: 'top top',
  scroller: '.smooth-scroll',
  end: 99999,
  onUpdate: (self) => {
    self.direction === -1 ? showAnim.play() : showAnim.reverse() 
  },
});

//homepage

const hero = gsap.timeline({repeat:-1, yoyo:true});

hero.to('#breathe path',  {
  duration: 4, 
 opacity: 0.6,
ease: 'power4.in',
  stagger: {
    from: 'random',
    ease: 'power4.inOut',
    amount: 1.5 },
});

//home logo

const logo = gsap.timeline({repeat:-1, yoyo:true});

logo.from('#wave',  { 
duration: 6,
 x: -20,
  stagger: {
    from: 'random',
    ease: 'slow(0.5, 0.8, true)',
    amount: 0.5,
  },
});

  // Draw Icons

gsap.utils.toArray('svg #draw').forEach(icons => {
    gsap.from(icons, {
      duration: 2, 
     drawSVG: 0,
     scrollTrigger: {
      scroller: '.smooth-scroll',
       trigger: icons,
       start: 'top 95%',
       end: 'top 60%',
       scrub: 1, 
       pinSpacing: false,
       markers: false,
     },
      stagger: {
        from: 'edges',
       ease: 'power4.inOut',
       amount: 1.5,
   },
  });
 })

  // Images

  gsap.utils.toArray('img.grow-up').forEach(images => {
    gsap.fromTo(images, {
     clipPath: 'polygon(0% 100%, 100% 100%, 100% 100%, 0% 100%)',
   }, { 
     scrollTrigger: {
      scroller: '.smooth-scroll',
       trigger: images,
       scrub: 1,
       start: 'center 100%',
       end: 'center 80%',
       markers: false,
     },
     clipPath: 'polygon(0% 0%, 100% 0%, 100% 100%, 0% 100%)',
   });
   })

   //content blocks


   gsap.utils.toArray('.col.pull').forEach(pull => {
    gsap.from(pull, {
  
     scrollTrigger: {
      scroller: '.smooth-scroll',
       trigger: pull,
       scrub: 1,
       start: 'top 80%',
       end: 'bottom 80%',
       markers: false,
     },
     y: 100,
     duration: 3,
   });
   })

   //Menu Background 


    gsap.to('header.banner', {
        scrollTrigger: {
          scroller: '.smooth-scroll',
          trigger: 'header.banner',
          start: 100,
          end: 99999999,
          scrub: 1, 
          pinSpacing: false,
          markers: false,
          toggleClass: 'reveal',
        },
      });

// Sliding Text

gsap.to('section.sliding-text ul.left', {
  x: '-10rem',
  scrollTrigger: {
    scroller: '.smooth-scroll',
    trigger: 'section.sliding-text ul.left',
    start: 'top 100%',
    end: 'top 0%',
    scrub: 1, 
    pinSpacing: false,
    markers: false,
  },
});

gsap.to('section.sliding-text ul.right', {
  x: '10rem',
  scrollTrigger: {
    scroller: '.smooth-scroll',
    trigger: 'section.sliding-text ul.right',
    start: 'top 100%',
    end: 'top 0%',
    scrub: 1, 
    pinSpacing: false,
    markers: false,
  },
});

// loco & Scrolltrigger

ScrollTrigger.addEventListener('refresh', () => locoScroll.update());
ScrollTrigger.refresh();

function locomotiveHeightBug() {
  locoScroll.update();
}
setInterval(locomotiveHeightBug, 5000);



// Load Events
jQuery(document).ready(() => routes.loadEvents());







// WEBPACK FOOTER //
// ./scripts/main.js